/** Replace product copy while preserving URLs, email addresses and API identifiers. */
export const replaceInstallationName = (text, installationName) => {
  if (!text || !installationName) return text;

  return text.replace(
    /(?<![\w/@.-])chatwoot(?![\w-]|\.[a-z0-9])/gi,
    () => installationName
  );
};

export const brandTranslation = text =>
  replaceInstallationName(text, window.globalConfig?.INSTALLATION_NAME);
